import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';
import { Validator, FormProperty, PropertyGroup } from '../angular2-schema-form-shim';

import * as rawJSONSchemaModulePainManagement from '../../schemas/module-pain-management.json';

export class SchemaModulePainManagement extends SchemaModuleUniversal {
  schema: JSONSchema<ModuleValueUniversal>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModulePainManagement );
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-pain-management.ts